export const CABIN_CLASS_MAP = {
  E: 'economy',
  B: 'business',
} as const;
